import { render, staticRenderFns } from "./benefits.vue?vue&type=template&id=219c40a9&scoped=true"
import script from "./benefits.vue?vue&type=script&lang=js"
export * from "./benefits.vue?vue&type=script&lang=js"
import style0 from "./benefits.vue?vue&type=style&index=0&id=219c40a9&prod&lang=css"
import style1 from "./benefits.vue?vue&type=style&index=1&id=219c40a9&prod&scoped=true&lang=css"
import style2 from "./benefits.vue?vue&type=style&index=2&id=219c40a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219c40a9",
  null
  
)

export default component.exports